var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React, { PureComponent } from 'react'; // import PropTypes from 'prop-types';

import { map, cloneDeep } from 'lodash';
import { Form as AntForm, Spin as AntSpin, Row as AntRow, Col as AntCol } from 'antd'; // import { basicPropTypes } from '../component-props';

import { Button } from '../button';
import { TypesManager } from '@comall-backend-builder/core'; // 栅格总列数

var GRID_COLUMN_NUMBER = 24;
/**
 * 根据属性路径获取表单域
 * @param path 属性路径
 * @param fields 顶级表单域结构
 */

export function getField(path, fields) {
  var propertyNames = path.split('.');
  var field;
  var fieldName = [];

  for (var _i = 0, propertyNames_1 = propertyNames; _i < propertyNames_1.length; _i++) {
    var name_1 = propertyNames_1[_i];
    fieldName.push(name_1);
    field = fields[fieldName.join('.')];

    if (!field) {
      break;
    }

    fields = field.fields;
  }

  return field;
}

var DetailView = function (_super) {
  __extends(DetailView, _super);

  function DetailView() {
    return _super !== null && _super.apply(this, arguments) || this;
  } // static propTypes = {
  //     ...basicPropTypes,
  //     fields: PropTypes.object,
  //     onInit: PropTypes.func,
  //     direction: PropTypes.oneOf(['horizontal', 'vertical', 'inline']),
  //     fieldRow: PropTypes.object,
  //     fieldCol: PropTypes.object,
  //     labelCol: PropTypes.oneOf(range(1, 25)),
  //     controlCol: PropTypes.oneOf(range(1, 25)),
  //     footer: PropTypes.shape({
  //         className: PropTypes.string,
  //         style: PropTypes.object,
  //         row: PropTypes.object,
  //         col: PropTypes.object,
  //         items: PropTypes.array,
  //     }),
  // };


  DetailView.prototype.componentWillMount = function () {
    var onInit = this.props.onInit;

    if (onInit) {
      onInit();
    }
  };

  DetailView.prototype.render = function () {
    var _a = this.props,
        direction = _a.direction,
        className = _a.className,
        style = _a.style,
        showSpin = _a.showSpin,
        state = _a.state,
        fieldRow = _a.fieldRow;
    var formFields = this.renderFormFields(state.fields);
    var form = React.createElement(AntForm, {
      layout: direction,
      className: className,
      style: style
    }, direction === 'inline' || !fieldRow ? formFields : React.createElement(AntRow, __assign({}, fieldRow), formFields), this.renderFormFooter());

    if (showSpin !== false) {
      var spinning = !!state && state.requestStatus === 'pending';
      return React.createElement(AntSpin, {
        spinning: spinning
      }, form);
    } else {
      return form;
    }
  };
  /**
   * 渲染展示域
   */


  DetailView.prototype.renderFormFields = function (fields) {
    var _this = this;

    var _a = this.props,
        direction = _a.direction,
        fieldCol = _a.fieldCol;
    return map(fields, function (field, fieldname) {
      if (field.type === 'object.subForm') {
        return _this.renderSubForm(fieldname, field);
      } else {
        var item = _this.renderFormItem(fieldname, field);

        if (direction === 'inline' || !fieldCol) {
          return item;
        } else {
          return React.createElement(AntCol, __assign({}, fieldCol, {
            key: fieldname
          }), item);
        }
      }
    });
  };
  /**
   * 渲染subForm
   */


  DetailView.prototype.renderSubForm = function (fieldname, field) {
    var _a = this.props,
        direction = _a.direction,
        fieldRow = _a.fieldRow;
    var formFields = this.renderFormFields(field.fields);

    if (direction === 'inline') {
      // 行内表单不添加子表单标题和缩进
      return formFields;
    } else {
      var label = field.displayName || fieldname;
      return React.createElement("fieldset", {
        className: "sub-form",
        key: fieldname
      }, React.createElement("legend", {
        className: "sub-form-title"
      }, cloneDeep(label)), fieldRow ? React.createElement(AntRow, __assign({}, fieldRow), formFields) : formFields);
    }
  };
  /**
   * 渲染展示项
   */


  DetailView.prototype.renderFormItem = function (fieldname, field) {
    var type = field.type,
        className = field.className;
    var label = field.label || field.displayName || fieldname;
    var value = field.value; // 表单项设置

    var formItemProps = __assign({
      key: fieldname,
      label: cloneDeep(label),
      className: className
    }, this.getFormItemLayout());

    return React.createElement(AntForm.Item, __assign({}, formItemProps), TypesManager.get(type).getDisplayComponent(value, __assign(__assign({}, field.displayConfig), {
      name: field.name,
      options: field.options,
      row: this.props.state.fieldValues
    })));
  };
  /**
   * 渲染页脚
   */


  DetailView.prototype.renderFormFooter = function () {
    var _a = this.props,
        direction = _a.direction,
        footer = _a.footer;
    var className = footer.className,
        style = footer.style,
        row = footer.row,
        col = footer.col,
        _b = footer.items,
        items = _b === void 0 ? [] : _b;
    var buttons = [];

    if (footer) {
      items.forEach(function (button, index) {
        buttons.push(React.createElement(Button, __assign({}, button, {
          key: index
        })));
      });
    }

    if (direction === 'inline') {
      return React.createElement(AntForm.Item, __assign({
        className: className,
        style: style
      }, this.getTailFormItemLayout()), buttons);
    } else {
      return React.createElement(AntRow, __assign({
        className: className,
        style: style
      }, row), React.createElement(AntCol, __assign({}, col), React.createElement(AntForm.Item, __assign({}, this.getTailFormItemLayout()), buttons)));
    }
  };
  /**
   * 获取布局设置
   */


  DetailView.prototype.getFormItemLayout = function () {
    var _a = this.props,
        direction = _a.direction,
        labelCol = _a.labelCol,
        controlCol = _a.controlCol;
    return direction === 'horizontal' ? {
      labelCol: {
        span: labelCol
      },
      wrapperCol: {
        span: controlCol || GRID_COLUMN_NUMBER - labelCol
      }
    } : undefined;
  };
  /**
   * 获取尾部布局设置
   */


  DetailView.prototype.getTailFormItemLayout = function () {
    var _a = this.props,
        direction = _a.direction,
        labelCol = _a.labelCol,
        controlCol = _a.controlCol;
    return direction === 'horizontal' ? {
      wrapperCol: {
        offset: labelCol,
        span: controlCol || GRID_COLUMN_NUMBER - labelCol
      }
    } : undefined;
  };

  DetailView.defaultProps = {
    direction: 'horizontal',
    labelCol: 8,
    footer: {
      items: []
    }
  };
  return DetailView;
}(PureComponent);

export { DetailView };